import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation, Outlet } from "react-router-dom";
import { LanguageProvider } from "./i18n/LanguageContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import ChiSiamo from "./pages/ChiSiamo";
import Innovazione from "./pages/Innovazione";
import CosaFacciamo from "./pages/CosaFacciamo";
import Ricette from "./pages/Ricette";
import Allf from "./pages/Allf";
import RistoranteAllf from "./pages/RistoranteAllf";
import Contatti from "./pages/Contatti";
import Hotel from "./pages/Hotel";
import Risorice from "./pages/Risorice";
import Admin from "./pages/Admin";
import NotFound from "./pages/NotFound";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [pathname]);
  return null;
}

function SiteLayout() {
  return (
    <>
      <Navbar />
      <Outlet />
      <Footer />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route element={<SiteLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/chi-siamo" element={<ChiSiamo />} />
              <Route path="/innovazione" element={<Innovazione />} />
              <Route path="/cosa-facciamo" element={<CosaFacciamo />} />
              <Route path="/ricette" element={<Ricette />} />
              <Route path="/allf" element={<Allf />} />
              <Route path="/ristorante-allf" element={<RistoranteAllf />} />
              <Route path="/hotel" element={<Hotel />} />
              <Route path="/risorice" element={<Risorice />} />
              <Route path="/contatti" element={<Contatti />} />
              <Route path="*" element={<NotFound />} />
            </Route>
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
